// extracted by mini-css-extract-plugin
module.exports = {"content":"integralDetail_content__1EOXq"};